import { Button } from "@/components/ui/button";

const InvitationSection = () => {
  return (
    <section className="py-24 md:py-32 bg-muted/40">
      <div className="container mx-auto px-4 max-w-3xl text-center">
        <p className="text-sm uppercase tracking-[0.2em] text-coral-text mb-6">One last invitation</p>

        <h2 className="text-3xl md:text-5xl font-heading font-bold leading-tight mb-6">
          Join the{" "}
          <span className="text-gradient-coral">movement.</span>
        </h2>

        <p className="text-muted-foreground text-lg leading-relaxed mb-10">
          You do not need a title, a diagnosis or a plan. You only need to be willing to see differently in the company
          of others.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button variant="coral" size="lg" asChild>
            <a href="https://airtable.com/appj9naWTSEyBxyub/shrahOKBrQHWbDb65" target="_blank" rel="noopener noreferrer">
              Join the Movement
            </a>
          </Button>
          <Button variant="outline" size="lg" asChild>
            <a href="#find-your-way-in">Find your way in</a>
          </Button>
        </div>

        <div className="w-16 h-[1px] bg-border mx-auto my-12" />

        <p className="text-lg md:text-xl font-heading font-bold text-foreground">
          Relationships are everything. That is the whole movement.
        </p>
      </div>
    </section>
  );
};

export default InvitationSection;